/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditMerchantPage,
    openViewMerchantDialog,
    openDeleteMerchantDialog,
    tabValues
  }
) => (
  <>
      <a
        title="Edit Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditMerchantPage(row.id,'wix',tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            title="Edit Merchant"
          />
        </span>
      </a>

      <a
        title="View Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm"
        onClick={() => openViewMerchantDialog(row.id,'wix',tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          
        <i className='fas fa-eye'></i>
        </span>
      </a>

      {/* <a
        title="Delete Merchant"
        className="btn btn-icon btn-light btn-hover-info btn-sm"
        onClick={() => openDeleteMerchantDialog(row._id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} title="Delete Merchant"/>
        </span>
      </a> */}

  </>
);
